export const fr = {
  title: `Les impacts de l’épilepsie`,
  adult: `Adulte`,
  children: `Enfant`
};
